import {
  OVERRIDE_COMMENT_ATTACHMENTS,
  OPEN_ADD_COMMENT_ATTACHMENTS,
} from '../types';

const defaultState = {
  attachments: {
    override: false,
    open: false,
  },
};

const attachments = (state = defaultState.attachments, action) => {
  switch (action.type) {
    case OVERRIDE_COMMENT_ATTACHMENTS:
      return Object.assign({}, state, {
        override: true,
      });

    case OPEN_ADD_COMMENT_ATTACHMENTS:
      return Object.assign({}, state, {
        open: true,
      });

    default:
      return state;
  }
};

export default attachments;



// WEBPACK FOOTER //
// ./src/state/reducers/attachments.js